import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import axios from "../../axios/axiosconf";

function HorarioAtencion() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [duracionCita, setDuracionCita] = useState("30");
    const [horaInicio, setHoraInicio] = useState("06:00:00");
    const [horaFin, setHoraFin] = useState("20:00:00");
    const [loadingDuracion, setLoadingDuracion] = useState(false);
    const [loadingHorario, setLoadingHorario] = useState(false);
    const [errorlist, setErrorlist] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastDelay, setToastDelay] = useState(3500);

    useEffect(() => {
        if (!localStorage.getItem("userdata")) {
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem("userdata"));
        const config = {
            headers: {
                Authorization: "Bearer " + userdata.access_token
            }
        };

        axios.get("/get-client?uid=" + userdata.user_id, config)
            .then((response) => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(() => { })
            .finally(() => setLoggedIn(true));

        axios.get("/perfil?uid=" + userdata.user_id, config)
            .then((response) => {
                if (response.status === 200 && response.data?.duracion_cita != null) {
                    setDuracionCita(String(response.data.duracion_cita));
                }
            })
            .catch(() => { });

        axios.get("/horario-agenda", config)
            .then((response) => {
                if (response.status === 200 && response.data) {
                    setHoraInicio(response.data.hora_inicio || "00:00:00");
                    setHoraFin(response.data.hora_fin || "23:59:00");
                }
            })
            .catch(() => { });
    }, []);

    const handleSubmitDuracion = (e) => {
        e.preventDefault();
        setLoadingDuracion(true);
        setErrorlist((prev) => ({ ...prev, duracion_cita: undefined }));

        const userdata = JSON.parse(localStorage.getItem("userdata") || "{}");
        const config = {
            headers: { Authorization: "Bearer " + userdata.access_token }
        };

        axios.put("perfil", {
            uid: userdata.user_id,
            duracion_cita: duracionCita
        }, config)
            .then((response) => {
                if (response.status === 200) {
                    userdata.step = duracionCita;
                    localStorage.setItem("userdata", JSON.stringify(userdata));
                    setToastMessage("Duración por defecto actualizada para todos los usuarios del cliente.");
                    setToastDelay(3500);
                    setShowToast(true);
                }
            })
            .catch((error) => {
                if (error.response?.data?.errors?.duracion_cita?.[0]) {
                    setErrorlist((prev) => ({ ...prev, duracion_cita: error.response.data.errors.duracion_cita[0] }));
                }
            })
            .finally(() => setLoadingDuracion(false));
    };

    const handleSubmitHorario = (e) => {
        e.preventDefault();
        setLoadingHorario(true);
        setErrorlist((prev) => ({ ...prev, hora_inicio: undefined, hora_fin: undefined }));

        const userdata = JSON.parse(localStorage.getItem("userdata") || "{}");
        const config = {
            headers: { Authorization: "Bearer " + userdata.access_token }
        };

        axios.put("/horario-agenda", {
            hora_inicio: horaInicio,
            hora_fin: horaFin
        }, config)
            .then((response) => {
                if (response.status === 200) {
                    setToastMessage("Horario de atención actualizado correctamente.");
                    setToastDelay(3500);
                    setShowToast(true);
                }
            })
            .catch((error) => {
                if (error.response?.data?.errors) {
                    const errors = error.response.data.errors;
                    setErrorlist((prev) => ({
                        ...prev,
                        hora_inicio: errors.hora_inicio?.[0],
                        hora_fin: errors.hora_fin?.[0]
                    }));
                }
            })
            .finally(() => setLoadingHorario(false));
    };

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        <div className="wrapper hold-transition" style={{ fontSize: "13px" }}>
            <Header client={client} />
            <Aside client={client} activelink="settings" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left mb-0">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item"><Link to="/parametros-agenda">Parámetros de agenda</Link></li>
                                    <li className="breadcrumb-item active">Horario de  Atención</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-end">
                            <div className="col-md-8">
                                <h1 className="m-0">Horario de Atención y Duración de Citas</h1>
                            </div>
                            <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link to="/parametros-agenda" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: "10px", fontWeight: 600 }}>
                                    <i className="fas fa-arrow-left mr-1"></i> Volver a parámetros de agenda
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <form onSubmit={handleSubmitHorario} className="card mb-3">
                            <div className="card-header">
                                <h3 className="card-title mb-0">
                                    <i className="fas fa-clock mr-2"></i>
                                    Horario de Atención
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="alert alert-secondary border-0">
                                    Configura el rango horario visible en las vistas de agenda para todo el cliente.
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="horaInicio">Hora de inicio</label>
                                            <input
                                                id="horaInicio"
                                                type="time"
                                                className="form-control"
                                                value={(horaInicio || "00:00:00").substring(0, 5)}
                                                onChange={(e) => setHoraInicio(e.target.value + ":00")}
                                                required
                                            />
                                            {errorlist.hora_inicio && <div className="invalid-feedback visible">{errorlist.hora_inicio}</div>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="horaFin">Hora de fin</label>
                                            <input
                                                id="horaFin"
                                                type="time"
                                                className="form-control"
                                                value={(horaFin || "23:59:00").substring(0, 5)}
                                                onChange={(e) => setHoraFin(e.target.value + ":00")}
                                                required
                                            />
                                            {errorlist.hora_fin && <div className="invalid-feedback visible">{errorlist.hora_fin}</div>}
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary">
                                    Guardar Horario&nbsp;
                                    {loadingHorario ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : null}
                                </button>
                            </div>
                        </form>

                        <form onSubmit={handleSubmitDuracion} className="card">
                            <div className="card-header">
                                <h3 className="card-title mb-0">
                                    <i className="fas fa-stopwatch mr-2"></i>
                                    Duración por Defecto de Citas
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="duracionCita">Duración (minutos)</label>
                                            <input
                                                id="duracionCita"
                                                type="number"
                                                min="10"
                                                max="120"
                                                className="form-control"
                                                value={duracionCita}
                                                onChange={(e) => setDuracionCita(e.target.value)}
                                                required
                                            />
                                            {errorlist.duracion_cita && <div className="invalid-feedback visible">{errorlist.duracion_cita}</div>}
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary">
                                    Guardar Duración&nbsp;
                                    {loadingDuracion ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : null}
                                </button>
                            </div>
                        </form>
                    </div>
                </section>
            </div>

            <Footer showToast={showToast} delay={toastDelay} message={toastMessage} />
        </div>
    );
}

export default HorarioAtencion;
